export function copyToClipboard(text: string) {
  if ("clipboard" in navigator) {
    navigator.clipboard.writeText(text);
  } else {
    console.error("Cannot copy to clipboard, 'clipboard' property not present in 'navigator' object");
  }
}
